import { useCallbackWithoutArguments } from "client/Hooks";
import { setTrackingId } from "client/Misc/utils";
import { ReactElement, PropsWithChildren } from "react";
import styles from "./DialogCard.module.less";

export type DialogCardProps = {
	onClick?: () => void;
	trackingId?: string;
};

export const DialogCard = (props: PropsWithChildren<DialogCardProps>): ReactElement => {
	const {
		onClick: onClickFromProps,
		trackingId,
		children
	} = props;

	const onClick: (() => void) | undefined = useCallbackWithoutArguments(onClickFromProps);

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}
			onClick={onClick}
		>
			{ children }
		</div>
	);
};
DialogCard.displayName = "Dialog.Card";
